export enum FilterByDate {
  TODAY = 'TODAY',
  LAST_7_DAYS = 'LAST_7_DAYS',
  LAST_30_DAYS = 'LAST_30_DAYS',
  ALL_DATES = 'ALL_DATES',
}
